var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["scroll-top", { "scroll-top--hidden": !_vm.isShown }] },
    [
      _c(
        "button",
        { staticClass: "scroll-top__btn", on: { click: _vm.scrollTop } },
        [
          _c("z-icon", {
            attrs: { name: "arrow_bold", width: "26", height: "26" },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }